import { Component, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BillingManagementService } from 'src/service/billing-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { KeyValues5, LocalService, NumericConfig, Status } from 'src/service/local.service';

@Component({
  selector: 'app-receipt-html',
  templateUrl: './receipt-html.component.html',
  styleUrl: './receipt-html.component.scss'
})
export class ReceiptHtmlComponent {
  elementIds: any; htmlId: string = '';
  lstSectionConfigKeys: string[] = ["seller", "common", "receipt"];
  numericConfig: NumericConfig = { isDecimalAllowed: false } as NumericConfig;
  data: KeyValues5 = {
    v1: '',
    v2: '',
    v3: '',
    v4: '',
    v5: '',
  } as KeyValues5;
  items: KeyValues5[] = [];

  parentId: string = ''; receiptType: number = 0;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private billingManagementService: BillingManagementService, private route: ActivatedRoute) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      type: 'type_' + this.htmlId,
      title: 'title_' + this.htmlId,
      save: 'save_' + this.htmlId,
      html: 'html_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.parentId = routeParams.parentId;
      this.receiptType = parseInt(routeParams.receiptType);
      this.onLoad();
    });
  }

  onLoad() {
    this.data = {
      v1: '',
      v2: '',
      v3: this.receiptType.toString(),
      v4: '',
      v5: this.parentId,
    } as KeyValues5;

    this.billingManagementService.getReceiptHtmls(this.parentId).subscribe(result => {
      this.items = result;
    });
  }

  onAction(action: number, key?: string) {
    switch (action) {
      case 1:
        if (key) {
          const item = this.items.find(x => x.key == key);
          if (item && item.v1 && item.v2 && item.v4) {
            this.onSave(item);
          }
        } else if (this.data.v1 && this.data.v2 && this.data.v4) {
          this.onSave(this.data);
        }
    }
  }

  onSave(data: KeyValues5) {
    this.billingManagementService.saveReceiptTemplate(data).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }
}
